<div class="modal-header">
  <h4 class="modal-title pull-left">
    <app-icon icon="compass" iconClass="button-icon"></app-icon> State Counties
  </h4>

  <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.hide()">
  </button>
</div>

<div class="modal-body">
  <form class="form" [formGroup]="stateCountiesForm" novalidate>

    @if (!stateId) {
      <dropdown [options]="filteredStateList"
        formControlName="state"
        (ngModelChange)="onStateSelect($event)">
      </dropdown>
    }

    <!--<label *ngIf="state" class="form-control">{{state}}</label>-->

    @if (counties.length > 0) {
      <multi-select
        [options]="counties"
        formControlName="counties">
      </multi-select>
    } @else {
      @if (!selectedStateId && !countiesLoaded) {
        <span>No State is selected</span>
      }
      @if (selectedStateId && !countiesLoaded) {
        <span>Loading...</span>
      }
      @if (selectedStateId && countiesLoaded) {
        <span>No counties exist for this state.</span>
      }
    }

  </form>
</div>


<div class="modal-footer">
  <button type="button"
    class="btn btn-default"
    (click)="modalRef.hide()">
    Close
  </button>
  @if (selectedStateId && counties.length > 0) {
    <button
      type="button"
      class="btn btn-success"
      [disabled]="!stateId && stateCountiesForm.invalid"
      (click)="done()">
      Done
    </button>
  }
</div>
